// Builds the adviser WhatsApp "video share" message: the 90-second promo plus
// the adviser's personal referral link, so registrations are tagged to them.
import { eventConfig } from "@/config/eventConfig";

const SITE = (eventConfig.publicSiteUrl || "").replace(/\/$/, "");

export const referralLink = (code) => (code ? `${SITE}/?ref=${code}` : `${SITE}/`);

/** Plain-text message with {video}, {link}, {date}, {time}, {venue} placeholders resolved. */
export function buildShareMessage(code, template = eventConfig.video.shareMessage) {
  const { event, video } = eventConfig;
  return template
    .replace(/{video}/g, video.shareUrl)
    .replace(/{link}/g, referralLink(code))
    .replace(/{date}/g, event.dateLabel)
    .replace(/{time}/g, event.timeLabel)
    .replace(/{venue}/g, event.venueLine1)
    .trim();
}

/** wa.me deep link with no recipient: WhatsApp asks the adviser to pick a contact/group. */
export const whatsappShareUrl = (message) => `https://wa.me/?text=${encodeURIComponent(message)}`;
